class GetAppointmentDayReq {
    constructor(){
        this.dateDay = undefined;
        
    }
}

export default GetAppointmentDayReq;
